export default {
  "about": {
    "careersDetails": {
      "anqing": "Аньцин",
      "applyResume": "Отправить резюме",
      "backToPrevious": "Вернуться назад",
      "category": "Категория:",
      "education": "Минимальное образование:",
      "errors": {
        "getInfoFailed": "Не удалось получить информацию",
        "getJobDetailFailed": "Не удалось получить детали вакансии",
        "getJobDetailFailedRetry": "Не удалось получить детали вакансии, пожалуйста, повторите позже",
        "jobNotExist": "Информация о вакансии не существует",
        "parseInfoFailed": "Не удалось разобрать информацию"
      },
      "jobDescription": "Описание вакансии",
      "jobRequirements": "Требования к должности",
      "nationwide": "По всей стране",
      "noJobInfo": "Информация о вакансии не существует",
      "person": "чел.",
      "recruitmentCount": "Количество вакансий:",
      "salary": "Зарплата:",
      "suzhou": "Сучжоу",
      "workLocation": "Место работы:",
      "workYear": "Опыт работы:"
    },
    "contact": {
      "address": "Адрес:",
      "contactInfo": "Контактная информация",
      "email": "Email:",
      "errors": {
        "getContactFailed": "Не удалось получить контактные данные"
      },
      "pageTitle": "Свяжитесь с нами",
      "phone": "Телефон:",
      "postcode": "Почтовый индекс:"
    },
    "page": {
      "careers": {
        "activities": {
          "balance": {
            "description": "Поддерживаем баланс между работой и личной жизнью",
            "subtitle": "KEEP BALANCED",
            "title": "Баланс и развитие"
          },
          "learning": {
            "description": "Создаем обучающую организацию, продвигаем непрерывное обучение",
            "subtitle": "KEEP LEARNING",
            "title": "Обучение без границ"
          }
        },
        "category": "Категория:",
        "errors": {
          "getAreaFailed": "Не удалось получить место работы",
          "getAreaFailedRetry": "Не удалось получить место работы, пожалуйста, повторите позже",
          "getCategoryFailed": "Не удалось получить категории вакансий",
          "getCategoryFailedRetry": "Не удалось получить категории вакансий, пожалуйста, повторите позже",
          "getJobsFailed": "Не удалось получить список вакансий",
          "getJobsFailedRetry": "Не удалось получить список вакансий, пожалуйста, повторите позже",
          "getNatureFailed": "Не удалось получить характер работы",
          "getNatureFailedRetry": "Не удалось получить характер работы, пожалуйста, повторите позже"
        },
        "jobCategory": "Категория вакансии",
        "jobNature": "Характер работы",
        "nationwide": "По всей стране",
        "noData": "Нет данных",
        "noJobs": "Нет соответствующих вакансий",
        "publishDate": "Опубликовано",
        "searchBox": {
          "campusRecruitment": "Кампусный набор",
          "placeholder": "Введите ключевое слово",
          "search": "Поиск",
          "socialRecruitment": "Социальный набор"
        },
        "viewDetail": "Подробнее >",
        "workLocation": "Место работы"
      },
      "company": {
        "companyIntro": "Основанная в 2003 году со штаб-квартирой в Сучжоу (Китай), после многих лет инновационного развития компания стала национальным высокотехнологичным предприятием, объединяющим НИОКР, производство, продажи и обслуживание. Сфера деятельности охватывает науки о жизни, личную гигиену, новые материалы, тщательный отбор научно-исследовательской продукции, тестирование и др.",
        "companyName": "Yacoo",
        "dataSection": {
          "founded": "Основана",
          "globalCustomers": "Глобальные клиенты",
          "globalPartners": "Глобальные партнеры",
          "patents": "Патентные заявки",
          "productionBase": "Годовая мощность",
          "salesCountries": "Страны и регионы продаж",
          "title": "Корпоративные данные",
          "unit": "тонн",
          "year": "год"
        },
        "history": {
          "title": "История развития"
        },
        "honor": {
          "title": "Награды и сертификаты"
        },
        "pageTitle": "О компании",
        "subtitle": "Компания Yacoo Science - инновационный лидер в области глобальных фармацевтических и химических материалов.",
        "vision": {
          "mission": {
            "description": "Стремимся продвигать технологический прогресс и инновации в области медицинских и химических материалов",
            "title": "Миссия"
          },
          "title": "Корпоративная философия",
          "values": {
            "description": "Честность и благодарность, ответственность и усердие, прагматизм и борьба, инновации и совершенство",
            "title": "Ключевые ценности"
          },
          "vision": {
            "description": "Стать мировым лидером в инновациях медицинских и химических материалов",
            "title": "Видение"
          }
        }
      },
      "production": {
        "intro": "Yacoo обладает стабильными и надежными производственными мощностями. В настоящее время построены две производственные базы в Цзинине и Аньцине, оснащенные передовым международным оборудованием и технологиями производства, ориентированными на разработку и производство высококачественных тонких химикатов. Общая мощность каждой базы превышает 100 000 тонн, и они прошли сертификацию систем менеджмента качества ISO9001, экологического менеджмента ISO14001 и профессионального здоровья и безопасности ISO45001.",
        "intro2": "Yacoo использует систему контроля качества 'нулевых дефектов', чтобы гарантировать, что каждая партия продукции соответствует высоким отраслевым стандартам, постоянно предоставляя глобальным клиентам стабильные и надежные решения по поставкам химикатов. Благодаря преимуществам масштабируемых мощностей, интеллектуального производства и полного контроля сырья, мы предоставляем решения 'от научных исследований до коммерческого производства' для стратегических новых отраслей, таких как здравоохранение и биотехнологии, помогая клиентам достичь стабильного развития.",
        "siteInfo": {
          "area": "Площадь:",
          "capacity": "Цеха и мощность:",
          "coreProducts": "Основная продукция:",
          "field": "Область применения:"
        },
        "title": "Производственные базы"
      },
      "quality": {
        "equipment": {
          "description": "Создав комплексную платформу испытательного оборудования, включающую ВЭЖХ, ГХ, ЯМР, поляриметры, ИК-спектрометры, ICP-OES, автоматические потенциометрические титраторы и кулонометрические анализаторы влажности, Yacoo может удовлетворить высокоточные и сложные требования клиентов к выпускному контролю в различных сценариях.",
          "devices": {
            "automaticTitrator": "Автоматический потенциометрический титратор",
            "broadbandNMR": "Широкополосный ЯМР-спектрометр",
            "gcms": "ГХ-МС",
            "icpSpectrometer": "ICP-OES",
            "infraredSpectrometer": "ИК-спектрометр",
            "karlFischer": "Кулонометрический анализатор влажности"
          },
          "title": "Испытательное оборудование"
        },
        "intro": "Yacoo гарантирует качество продукции за счет контроля процессов, сосредоточившись на предоставлении клиентам более экономичных разнообразных продуктов и более качественных услуг, взяв на себя обязательство обслуживать инновации клиентов. Опираясь на 22-летний опыт Yacoo в области тестирования медицинских и химических материалов и научно-аналитическую команду под руководством нескольких докторов наук, мы предоставляем клиентам комплексные решения от тестирования до технической оптимизации.",
        "intro2": "Испытательная платформа Yacoo имеет современную лабораторию площадью 3000 м², оснащенную передовой в стране системой циркуляции и очистки воздуха, обеспечивающей безопасную и контролируемую испытательную среду. Платформа оснащена комплексным химическим аналитическим пространством и полным набором высококлассного оборудования, отвечающего требованиям высокой точности и сложности. В соответствии с законами, нормами и техническими стандартами различных стран/регионов (такими как REACH ЕС, FDA США, CDE Китая и т. д.) мы помогаем клиентам избегать торговых барьеров и добиваться соответствия на протяжении всего жизненного цикла продукта.",
        "navigation": {
          "next": "Следующий",
          "prev": "Предыдущий"
        },
        "system": {
          "description": "Yacoo создала всеобъемлющую систему тестирования медицинских и химических материалов, включая характеристику структуры, физико-химические свойства, элементный анализ, спектральный анализ, исследования стабильности, полную прослеживаемость данных, исследования примесей и тестирование сырья и вспомогательных материалов. Управление качеством сертифицировано по системе GMP и ISO9001:2015, поддерживая разработку и применение клиентов на глобальных рынках.",
          "title": "Система тестирования"
        },
        "title": "Управление качеством"
      }
    },
    "tabs": {
      "careers": "Присоединиться к нам",
      "company": "О компании",
      "production": "Производственные базы",
      "quality": "Управление качеством"
    }
  },
  "dzhc": {
    "businessIntroText": "Индивидуальные услуги являются основным бизнесом Yacoo. Опираясь на 22-летний опыт исследований и разработок в области медицинских и химических материалов, Yacoo может предоставить клиентам надежные и стабильные индивидуальные услуги 'под ключ'. У нас есть команда исследований и разработок и контроля качества, состоящая из опытных ученых и инженеров, созданы пять экспериментальных платформ, включая платформу искусственного интеллекта для синтеза, платформу химического синтеза, платформу биосинтеза и т. д., а также оснащены передовые испытательные платформы, такие как ВЭЖХ, ГХ и поляриметры. Кроме того, Yacoo имеет две производственные базы с годовой мощностью более 100 000 тонн, что позволяет удовлетворить все потребности клиентов в области медицинских и химических материалов, от индивидуального синтеза до услуг CRO и CDMO.",
    "businessIntroTitle": "Обзор бизнеса",
    "businessItems": ['Полимерные материалы', 'Мономеры полимеров', 'Фармацевтические промежуточные продукты', 'Новые электронные химические материалы', 'Материалы для клинических испытаний'],
    "caseTabs": [{"title":"Команда экспертов в области медицинских и химических материалов","description":"Состоит из почти 100 опытных ученых и инженеров, более 40% имеют степень магистра или доктора, подано более 150 патентных заявок на исследования и разработки, одобрено более 50."},{"title":"Передовые платформы для исследований и тестирования","description":"Созданы пять экспериментальных платформ, включая платформу искусственного интеллекта для синтеза, платформу химического синтеза, платформу биосинтеза и т. д., а также оснащены передовые испытательные платформы, такие как ВЭЖХ, ГХ и поляриметры."},{"title":"Гарантия международной системы качества","description":"Строго следуем международным стандартам ISO, полный контроль качества на всех этапах, обеспечивая высокую надежность продукции. От отбора сырья до готовой продукции, многоуровневые контрольные точки, полный контроль качества на всех этапах."}],
    "coreBusinessTitle": "Основной бизнес",
    "featureTitle": "Особенности услуг",
    "pageSubtitle": "Индивидуальные услуги CRO+CDMO для медицинских и химических продуктов",
    "pageTitle": "Индивидуальные услуги",
    "processItems": [{"title":"Дизайн маршрута","desc":['Более 100 опытных исследователей','ИИ-ассистент для дизайна маршрутов синтеза']},{"title":"Исследовательский синтез","desc":['Более 10 000 м² исследовательских лабораторий','Покрывает 80% обычных реакций']},{"title":"Производство образцов","desc":['Более 200 000 м² заводского производства','Строгий контроль качества, гарантия качества']},{"title":"Упаковка и отправка","desc":['Удовлетворение различных требований к упаковке и отправке твердых/жидких образцов','Профессиональная отправка образцов/отслеживание логистики']}],
    "processTitle": "Процесс индивидуального синтеза",
    "startProject": "Начните свой индивидуальный проект сейчас",
    "startProjectDesc": "Опишите ваши потребности, и наша профессиональная команда предоставит индивидуальные технические консультации и решения.",
    "viewMore": "Узнать больше"
  },
  "header": {
    "contactUs": "Свяжитесь с нами",
    "menu": {
      "about": "О Yacoo",
      "companyProfile": "Профиль компании",
      "customSynthesis": "Индивидуальные услуги",
      "greenEnergy": "Зеленая энергия",
      "innovation": "Инновационные достижения",
      "joinUs": "Присоединиться к нам",
      "news": "Новости",
      "other": "Другие услуги",
      "production": "Производственные базы",
      "products": "Продукция",
      "quality": "Управление качеством",
      "rAndDSystem": "Система НИОКР",
      "researchPurchase": "Научные закупки",
      "smartPlatform": "Интеллектуальная платформа",
      "solution": "Отраслевые решения",
      "sustainability": "Устойчивое развитие",
      "technology": "Технологические инновации",
      "testingService": "Услуги тестирования"
    },
    "searchPlaceholder": "Введите поисковый запрос..."
  },
  "home": {
    "about": {
      "description": "Основанная в 2003 году со штаб-квартирой в Сучжоу (Китай), после многих лет инновационного развития компания стала национальным высокотехнологичным предприятием, объединяющим НИОКР, производство, продажи и обслуживание. Сфера деятельности охватывает науки о жизни, личную гигиену, новые материалы, тщательный отбор научно-исследовательской продукции, тестирование и др.",
      "learnMore": "Узнать больше",
      "subtitle": "Компания Yacoo Science - инновационный лидер в области глобальных фармацевтических и химических материалов.",
      "title": "О Yacoo"
    },
    "globalService": {
      "description": "Yacoo может предоставить глобальным клиентам комплексные услуги CRO+CMO от индивидуального синтеза до масштабного производства, удовлетворяя все ваши потребности в продукции от научных исследований до коммерческого производства.",
      "legend": {
        "customers": {
          "en": "Our Customers",
          "zh": "Клиенты"
        },
        "headquarters": {
          "en": "Yacoo Headquarter",
          "zh": "Штаб-квартира Yacoo"
        },
        "subsidiaries": {
          "en": "Subsidiary Companies",
          "zh": "Дочерние компании Yacoo"
        }
      },
      "stats": {
        "title": "Глобальное присутствие",
        "capacity": "Дочерние компании в Сингапуре, США и Германии",
        "patents": "Более 15 000 глобальных клиентов",
        "team": "Охват более 70 стран"
      },
      "title": "Глобальная сервисная сеть"
    },
    "news": {
      "noNews": "Нет соответствующих новостей",
      "pageTitle": "Новости",
      "searchPlaceholder": "Введите ключевое слово",
      "title": "Новости Yacoo",
      "topTag": "Закреплено",
      "viewDetail": "Подробнее",
      "viewMore": "Узнать больше"
    },
    "solutions": {
      "title": "Продукты и решения"
    }
  },
  "jcfw": {
    "actionBtn": "Консультация",
    "businessIntroText1": "Wonder Testing - это независимая платформа тестирования под Yacoo. Опираясь на 22-летний опыт Yacoo в области тестирования медицинских и химических материалов, Wonder Testing стремится создать международную платформу услуг по качеству, предоставляя услуги тестирования, сертификации и соответствующие консультации для отечественных и зарубежных производственных предприятий/торговых компаний в соответствии с аккредитацией CMA (Китайская метрологическая сертификация) и признанием лаборатории CNAS (ISO/IEC 17025), в соответствии с различными (странами/регионами) законами/нормами/техническими стандартами. Мы предоставляем клиентам комплексные решения от тестирования до технической оптимизации.",
    "businessIntroText2": "Платформа Wonder Testing имеет современную лабораторию площадью 3000 м², оснащенную передовой в стране системой циркуляции и очистки воздуха, обеспечивающей безопасную и контролируемую испытательную среду. Платформа оснащена комплексным химическим аналитическим пространством и полным набором высококлассного оборудования, отвечающего требованиям высокой точности и сложности. В соответствии с законами, нормами и техническими стандартами различных стран/регионов (такими как REACH ЕС, FDA США, CDE Китая и т. д.) мы помогаем клиентам избегать торговых барьеров и добиваться соответствия на протяжении всего жизненного цикла продукта.",
    "businessIntroTitle": "Обзор бизнеса",
    "businessItems": ["Услуги тестирования","Медицинские исследования и экспериментальные разработки","Технические услуги тестирования","Сертификационные услуги"],
    "businessItemsClass": ["Потребительские товары","Электроника и бытовая техника","Игрушки и детские товары","Материалы, контактирующие с пищевыми продуктами","Автомобильные материалы","Легкая промышленность и текстиль"],
    "businessTip": "Лаборатория создала комплексную систему услуг тестирования, способную удовлетворить потребности в химическом и физическом тестировании потребительских товаров, электроники и бытовой техники, игрушек и детских товаров, материалов, контактирующих с пищевыми продуктами, автомобильных материалов, легкой промышленности и текстиля.",
    "caseTabs": [{"title":"Опыт в области сертификации соответствия","description":"Лаборатория, опираясь на 22-летний опыт Yacoo в области услуг тестирования медицинских и химических материалов, стремится предоставлять глобальным производителям и торговцам услуги тестирования соответствия, сертификации и технических консультаций."},{"title":"Сертификация международных стандартов управления","description":"Показатели тестирования и система управления соответствуют требованиям международных систем качества, получили признание многих ведущих международных клиентов, обеспечивая авторитетность и достоверность данных тестирования."},{"title":"Комплексный охват возможностей тестирования","description":"Предоставляем комплексные услуги в области химического тестирования потребительских товаров, оценки безопасности детских игрушек, тестирования текстиля, тестирования соответствия материалов, контактирующих с пищевыми продуктами, анализа автомобильных материалов и других областях, помогая предприятиям соответствовать требованиям различных нормативных актов (таких как REACH, FDA, CDE и т. д.)."}],
    "contact": {
      "address": "Адрес: 8 этаж, 112 XinQing Road, Industrial Park, Suzhou",
      "email": "Email: service@wondertesting.cn",
      "phone": "Телефон: +86-18625246998",
      "postcode": "Почтовый индекс: 215121"
    },
    "contactTitle": "Свяжитесь с нами",
    "coreBusinessTitle": "Основной бизнес",
    "equipmentDesc": "Создав комплексную платформу испытательного оборудования, включающую ВЭЖХ, ГХ, ЯМР, поляриметры, ИК-спектрометры и т. д., Yacoo может удовлетворить высокоточные и сложные требования клиентов к выпускному контролю в различных сценариях.",
    "equipmentList": ["ИК-спектрометр","Широкополосный ЯМР-спектрометр","Кулонометрический анализатор влажности","ГХ-МС","Автоматический потенциометрический титратор"],
    "equipmentTitle": "Испытательное оборудование",
    "featureTitle": "Особенности услуг",
    "nextBtn": "Следующий",
    "pageSubtitle": "Интегрированный поставщик услуг от независимого тестирования до технической оптимизации",
    "pageTitle": "Услуги тестирования",
    "platformDesc": "Интегрированный поставщик услуг тестирования и сертификации",
    "prevBtn": "Предыдущий",
    "shopSubtitle": "Интегрированный поставщик услуг от независимого тестирования до технической оптимизации",
    "shopTitle": "Wonder Testing",
    "viewMore": "Узнать больше"
  },
  "kycg": {
    "actionBtn": "Получить решение",
    "businessIntroText": "Element Mall (www.b2star.com) - это профессиональная платформа электронной коммерции для научных закупок под Yacoo. Интегрируя каналы поставщиков качественных брендов внутри страны и за рубежом, мы предоставляем профессиональные научные реагенты, средства защиты, биологические расходные материалы, лабораторное оборудование и сопутствующие продукты, стремясь лучше удовлетворить разнообразные потребности клиентов в области наук о жизни, биомедицины и новых материалов как внутри страны, так и за рубежом.",
    "businessIntroTitle": "Обзор бизнеса",
    "businessItems": [{"title":"Научные реагенты","desc":"Биологические реагенты, химические реагенты, аналитические реагенты, другие реагенты"},{"title":"Средства защиты","desc":"Защита рук, защита головы, защита лица, другие средства защиты"},{"title":"Биологические расходные материалы","desc":"Культура клеток, медицинские расходные материалы, хроматографические расходные материалы, тестовые расходные материалы, пипеточные расходные материалы, инструментальные расходные материалы"},{"title":"Лабораторное оборудование","desc":"Обычные приборы, тестовые приборы, хроматографические приборы, специальные приборы, средства безопасности"}],
    "caseTabs": [{"title":"24-часовой отклик на отгрузку","description":"Мультискладская прямая отгрузка, экспресс-доставка"},{"title":"Более 6 млн спецификаций продуктов","description":"Множество брендов, полный ассортимент"},{"title":"Более 600 известных партнерских брендов","description":"Авторизация производителей, гарантия подлинности"},{"title":"Заботливый сервис закупок","description":"Много выгод, профессиональный сервис"}],
    "contact": {
      "addressSuqian": "Адрес (Суцянь): г. Суцянь, Центр цифровой экономики Суцяня, корпус B3, офис 1201",
      "addressSuzhou": "Адрес (Сучжоу): 112 XinQing Road, Industrial Park, Suzhou",
      "addressWuhan": "Адрес (Ухань): 11-07, Building T3, Optical Valley Headquarters Center, 766 Gaoxin Avenue, East Lake High-tech Development Zone, Wuhan",
      "addressChengdu": "Адрес (Чэнду): 706, Building 3, Dingsheng International, Wuke West 1st Road, Wuhou District, Chengdu",
      "email": "Email: sxg@b2star.com",
      "phone": "Телефон: 15335295587"
    },
    "contactTitle": "Свяжитесь с нами",
    "coreBusinessTitle": "Основной бизнес",
    "enterShop": "Перейти к заказу",
    "featureTitle": "Особенности услуг",
    "pageSubtitle": "Платформа для научных закупок 'все в одном'",
    "pageTitle": "Научные закупки",

    "shopBusiness": ["Научные реагенты","Средства защиты","Биологические расходные материалы","Лабораторное оборудование"],

    "shopSubtitle": "Платформа для научных закупок 'все в одном'",

    "shopTitle": "Element Mall"

  },

  "lsny": {
    "actionBtn": "Получить образец",
    "businessIntroText": "Goodenough Chem (www.goodenoughchem.com(www.goodenoughchem.com)) - это платформа зеленой энергии под Yacoo. Самостоятельно разработанный огнестойкий отвердитель in situ эффективно повышает безопасность батарей и получил признание многих ведущих предприятий. Как интегрированный поставщик материалов для литиевых батарей нового поколения, Goodenough Chem может удовлетворить все ваши потребности от научных исследований до масштабного производства, предоставляя базовую конфигурацию электролита, сырье для электролитов, а также специальные функциональные электролиты, профессиональные услуги по конфигурации больших объемов электролита/индивидуальные услуги по электролитам.",

    "businessIntroTitle": "Обзор бизнеса",

    "businessItems": [{"title": "Электролиты"},{"title": "Химические реагенты"},{"title": "Материалы для батарей"},{"title": "Специальные функциональные электролиты"}],

    "caseTabs": [{"title":"Богатый ассортимент продуктов","description":"Завершена разработка почти 100 функциональных добавок для литиевых батарей нового поколения, могут предоставляться электролиты лития/натрия/магния/алюминия."},{"title":"От индивидуальной разработки до массового производства","description":"Способность к промышленному производству более 10 функциональных материалов для литиевых батарей, среди которых серия продуктов этоксифосфазенов планируется на уровне сотен тонн."},{"title":"Признание ведущих предприятий","description":"Показатели огнестойких продуктов достигают международного уровня, получили признание многих ведущих предприятий новой энергетики в стране."}],

    "contactAddress": "Адрес: 8 этаж, 112 XinQing Road, Industrial Park, Suzhou",

    "contactEmail": "Email: sales022@b2star.com(mailto:sales022@b2star.com)",

    "contactPhone": "Телефон: 18136447806",

    "contactPostcode": "Почтовый индекс: 215121",

    "contactQQ": "QQ: 693755679",

    "contactSubtitle": "Интегрированный поставщик материалов для литиевых батарей нового поколения",

    "contactTitle": "Свяжитесь с нами",

    "coreBusinessTitle": "Основной бизнес",

    "enterShop": "Узнать больше",

    "featureTitle": "Особенности услуг",

    "pageSubtitle": "Интегрированный поставщик материалов для литиевых батарей нового поколения",

    "pageTitle": "Зеленая энергия",

    "shopSubtitle": "Интегрированный поставщик материалов для литиевых батарей нового поколения",

    "shopTitle": "Goodenough Chem"

  },

  "news": {

    "searchBtn": "Поиск",

    "filter": "Сеять категории новостей",

    "noNews": "Нет соответствующих новостей",

    "pageTitle": "Новости",

    "searchPlaceholder": "Введите ключевое слово",

    "title": "Новости Yacoo",

    "topTag": "Закреплено",

    "viewDetail": "Подробнее",

    "viewMore": "Узнать больше"

  },

  "products": {

    "centerTitle": "Центр продукции",
    "screening": "Сеять категорию продукции",
    "detail": {

      "advantages": "Преимущества сервиса",

      "batchInquiry": "Запрос на оптовую закупку",

      "breadcrumbCenter": "Центр продукции",

      "breadcrumbHome": "Главная",

      "cas": "CAS: {cas}",

      "customSynthesis": "Консультация по индивидуальному синтезу",

      "featured": "Рекомендуемые продукты",

      "features": "Особенности продукта",

      "getSample": "Получить образец",

      "noData": "Нет данных",

      "notes": "Примечания",

      "related": "Рекомендуемые сопутствующие продукты",

      "researchPurchase": "Научные закупки"

    },

    "mainProducts": "Основная продукция",

    "noData": "Нет данных",

    "searchBtn": "Поиск",

    "searchPlaceholder": "Введите название продукта, артикул, номер CAS или ключевое слово",

    "panel": {

      "EnglishName": "Английское название",

      "Name": "Название",

      "Alias": "Альтернативные названия",

      "CAS": "Номер CAS",

      "UsagePlatform": "Платформа применения",

      "ArtNo": "Артикул",

      "molecularFormula": "Молекулярная формула",

      "molecularWeight": "Молекулярная масса",

      "ec": "Номер EC",

      "enzymeActivity": "Активность фермента",

      "activity": "Активность"

    }

  },

  "solution": {

    "learnMore": "Узнать больше",

    "pageSubtitle": "Продвижение технологического прогресса и инноваций в области медицинских и химических материалов",

    "pageTip": "Yacoo всегда сосредоточена на продвижении технологического прогресса и инноваций в области медицинских и химических материалов. Основываясь на технологических инновациях и стабильных поставках, мы удовлетворяем профессиональные потребности клиентов, предоставляя качественные, удобные и экономически эффективные разнообразные продукты и услуги, способствуя непрерывному прогрессу отрасли медицинских и химических материалов и создавая зеленое и здоровое будущее вместе.",

    "pageTitle": "Отраслевые решения",

    "tableName": "Название"

  },

  "sustainability": {

    "conceptText": "Yacoo всегда придерживается концепции устойчивого развития, интегрируя зеленые инновации во все процессы исследований, производства и операций. Мы стремимся сократить углеродный след за счет оптимизации экологически чистых процессов, повторного использования ресурсов и применения чистой энергии; содействовать разработке биоразлагаемых материалов и зеленых решений с помощью технологических инноваций, помогая отрасли перейти на низкоуглеродное развитие. В то же время мы активно выполняем социальную ответственность, создавая систему взаимовыгодного развития с сотрудниками, сообществами и окружающей средой, стремясь к синергии экономической, экологической и социальной эффективности и внося вклад в глобальные цели устойчивого развития.",

    "conceptTitle": "Концепция устойчивого развития",

    "dataSection": {

      "highConcentrationGas": "Доля зеленой электроэнергии",

      "lowConcentrationGas": "Эквивалент CO2/миллион юаней",

      "solidWasteStorage": "Пожертвование книг в среднюю школу №2 Кызыл-Суу",

      "wastewaterTreatment": "Пожертвования на социальные нужды в 2024 году",

      "units": {

        "cubicMeterPerHour": "%",

        "ton": "тонн",

        "tonPerDay": "экз.",

        "yuan": "юаней"

      }

    },

    "environmentalProtection": {

      "altText": "Охрана окружающей среды",

      "description": "Yacoo строго соблюдает соответствующие национальные и местные законы и нормативные акты об охране окружающей среды, а также другие соответствующие правила, прошла сертификацию системы экологического менеджмента ISO14001. Имеет совершенные объекты для обработки трех видов отходов, внедряя передовые объекты для обработки сточных вод, выбросов и твердых отходов, что позволяет безопасно проводить производственную деятельность при дружественном отношении к окружающей среде.",

      "title": "Охрана окружающей среды"

    },

    "greenDevelopment": {

      "buildingAlt": "Штаб-квартира Yacoo",

      "description": "Руководствуясь первоначальной идеей компании 'Выходя за границы медицинских и химических материалов, совместно создавая зеленое будущее', Yacoo всегда считает зеленое развитие своей миссией как в инфраструктурном строительстве, так и в разработке продуктов. Штаб-квартира группы получила платиновый сертификат LEED (Лидерство в энергетическом и экологическом проектировании) от Американского совета по зеленому строительству, обеспечивая энергоснабжение за счет зеленых энергетических устройств, таких как солнечные панели. Yacoo разработала новый биоматериал поли(2,5-фурандикарбоксилат этилена) (PEF) на основе возобновляемых сельскохозяйственных культур, который может широко применяться в области бутылочных преформ, значительно сокращая общий углеродный след в процессе производства продукции.",

      "title": "Зеленое развитие"

    },

    "pageSubtitle": "Индивидуальные услуги CRO+CDMO для медицинских и химических продуктов",

    "pageTitle": "Устойчивое развитие",

    "safetyProduction": {

      "certificateAlt": "Сертификат экологической сертификации",

      "description": "Yacoo разработала совершенную систему управления производственной безопасностью в соответствии с требованиями системы управления профессиональным здоровьем и безопасностью ISO45001. Благодаря информационным и интеллектуальным объектам мы защищаем линию безопасности. Например, производственная база Yacoo в Аньцине получила сертификат третьего уровня стандартизации производственной безопасности, создала информационную систему производственной безопасности, реализовав пятикомпонентную систему предотвращения рисков безопасности, включая позиционирование персонала, интеллектуальный контроль, двойную профилактику и т. д.",

      "title": "Производственная безопасность"

    }

  },

  "technology": {

    "achievementsTitle": "Инновационные достижения",

    "businessIntroText": "Yacoo имеет исследовательский центр площадью более 10 000 м², оснащенный передовым оборудованием, таким как платформа искусственного интеллекта для синтеза, микроканальные реакторы непрерывного потока и т. д., а также сформировала исследовательскую команду из более чем 100 человек, в основном с учеными степенями магистра и доктора. Благодаря углубленному сотрудничеству между промышленностью, образованием и исследованиями с такими университетами, как Нинбоский институт материалов Китайской академии наук и Сучжоуский университет, были созданы инновационные платформы, такие как 'Центр инженерных технологий провинции Цзянсу' и 'Совместный инновационный центр JITRI-Yacoo', сформировав совершенную систему исследований и трансформации результатов. На сегодняшний день компания подала более 150 патентных заявок.",

    "businessIntroTitle": "Совершенная система НИОКР",

    "businessItems": [{"title":"Биомедицинские очищающие агенты и структурные химикаты"},{"title":"Разработка реагентов для высококачественной in vitro диагностики"},{"title":"Разработка биологических ферментов"},{"title":"Разработка высококачественных биополимерных материалов"},{"title":"Электронные химикаты уровня полупроводников и материалы для батарей новой энергетики"}],

    "consultBtn": "Консультация по индивидуальному заказу",

    "customServiceDesc": "Опираясь на 22-летний опыт исследований и разработок в области медицинских и химических материалов, Yacoo может предоставить клиентам надежные и стабильные услуги индивидуального синтеза.",

    "customServiceTitle": "Индивидуальные услуги от граммов до тонн",

    "leadingProcess": "Передовые технологии",

    "pageTitle": "Интеллектуальные технологии создают будущее",

    "platformList": [{"title":"Лаборатория искусственного интеллекта","description":"Лаборатория искусственного интеллекта для синтеза оснащена синтезатором с ИИ, который может настраивать этапы реакции и параметры, осуществлять мониторинг процесса реакции в реальном времени, быстро отбирать технологические условия и прогнозировать оптимальные условия реакции, повышая эффективность исследований и разработок."},{"title":"Лаборатория очистки высококачественных реагентов","description":"Используется для очистки химикатов фармацевтического уровня и электронных материалов уровня полупроводников. Лаборатория оснащена передовым оборудованием для очистки, позволяющим проводить эксперименты по дистилляции, мембранной фильтрации и другим технологиям очистки кислот, спиртов, аминов, нитрилов и других соединений."},{"title":"Специализированная лабораторная платформа для электролитов новой энергетики","description":"Платформа может проводить эксперименты с огнестойкими добавками и электролитами. Оснащена **оборудованием, успешно завершила разработку серии фосфазеновых огнестойких добавок. Может продолжать разработку материалов для жидких и полужидких батарей в соответствии с технологическим путем батарей клиента."},{"title":"Лабораторная платформа зеленых технологий биосинтеза","description":"Биосинтез проводится при комнатной температуре и нормальном давлении, с низким энергопотреблением, без органических растворителей, с уменьшением или отсутствием токсичных побочных продуктов. Платформа разрабатывает продукты биологических буферных агентов на основе ферментативного катализа, новые диагностические субстраты и высокомолекулярные полиэфирные материалы."},{"title":"Лабораторная платформа химического синтеза","description":"Лаборатория химического синтеза, помимо традиционного синтетического оборудования, оснащена ЯМР (ЯМР), масс-спектрометрами (МС), ВЭЖХ (ВЭЖХ), автоматизированными рабочими станциями для микроканального синтеза непрерывного потока, системой управления лабораторными данными (LIMS). Может выполнять разработку фармацевтических вспомогательных веществ, диагностических субстратов и высокомолекулярных композитных материалов, включая индивидуальную разработку для клиентов."}],

    "platformTitle": "Пять интеллектуальных платформ для исследований и разработок",

    "serviceIcons": ["Биомедицинские очищающие агенты и структурные химикаты","Разработка реагентов для высококачественной in vitro диагностики","Разработка биологических ферментов","Разработка высококачественных биополимерных материалов","Электронные химикаты уровня полупроводников и материалы для батарей новой энергетики"],

    "starProduct": "Инновационные продукты"

  },

  "footer": {

    "contact": {

      "phone": "Телефон",

      "email": "Email"

    },

    "qrCode": {

      "scanToFollow": "Сканируйте, чтобы подписаться"

    },

    "socialMedia": {

      "wechat": "WeChat",

      "tiktok": "TikTok",

      "xiaohongshu": "Xiaohongshu"

    },

    "copyright": "© 2025 Suzhou Yacoo Technology Co., Ltd.",
    "icp": "苏ICP备15045967号"

  },

  "croCdmoDialog": {

    "logoAlt": "Логотип Yacoo",

    "hotline": "Бесплатная горячая линия:",

    "description": "Пожалуйста, оставьте информацию о ваших потребностях, мы свяжемся с вами в течение 1 рабочего дня",

    "form": {

      "name": "Имя",

      "namePlaceholder": "Введите ваше имя",

      "contact": "Контактная информация",

      "contactPlaceholder": "Введите ваш телефон/мобильный/email",

      "company": "Название компании",

      "companyPlaceholder": "Введите название вашей компании",

      "product": "Название продукта",

      "productPlaceholder": "Введите название продукта",

      "cas": "Номер CAS",

      "casPlaceholder": "Введите номер CAS",

      "requirement": "Потребности в закупке",

      "requirementPlaceholder": "Опишите ваши потребности в закупке",

      "attachment": "Вложение",

      "submit": "Отправить"

    },

    "upload": {

      "clickToUpload": "Нажмите для загрузки вложения",

      "fileFormat": "Формат файла: jpg, pdf, doc, размер не более 5M",

      "fileSizeError": "Размер файла не должен превышать 5M",

      "fileTypeError": "Пожалуйста, загрузите файл в формате jpg, pdf или doc",

      "uploadSuccess": "Файл успешно загружен",

      "uploadFailed": "Не удалось загрузить файл, попробуйте снова"

    },

    "validation": {

      "nameRequired": "Пожалуйста, введите имя",

      "contactRequired": "Пожалуйста, введите контактную информацию",

      "casRequired": "Пожалуйста, введите номер CAS"

    },

    "messages": {

      "submitSuccess": "Успешно отправлено",

      "submitFailed": "Не удалось отправить",

      "submitFailedRetry": "Не удалось отправить, пожалуйста, повторите позже"

    }

  },

  "productDialog": {

    "logoAlt": "Логотип Yacoo",

    "hotline": "Бесплатная горячая линия:",

    "description": "Пожалуйста, оставьте информацию о ваших потребностях, мы свяжемся с вами в течение 1 рабочего дня",

    "form": {

      "name": "Имя",

      "namePlaceholder": "Введите ваше имя",

      "contact": "Контактная информация",

      "contactPlaceholder": "Введите ваш телефон/мобильный/email",

      "company": "Название компании",

      "companyPlaceholder": "Введите название вашей компании",

      "product": "Название продукта",

      "productPlaceholder": "Введите название продукта",

      "cas": "Номер CAS",

      "casPlaceholder": "Введите номер CAS",

      "requirement": "Потребности в закупке",

      "requirementPlaceholder": "Опишите ваши потребности в закупке",

      "submit": "Отправить"

    },

    "validation": {

      "nameRequired": "Пожалуйста, введите имя",

      "contactRequired": "Пожалуйста, введите контактную информацию",

      "casRequired": "Пожалуйста, введите номер CAS"

    },

    "messages": {

      "submitSuccess": "Успешно отправлено",

      "submitFailed": "Не удалось отправить",

      "submitFailedRetry": "Не удалось отправить, пожалуйста, повторите позже"

    }

  },

  "serviceDialog": {

    "logoAlt": "Логотип Yacoo",

    "hotline": "Бесплатная горячая линия:",

    "description": "Пожалуйста, оставьте информацию о ваших потребностях, мы свяжемся с вами в течение 1 рабочего дня",

    "form": {

      "name": "Имя",

      "namePlaceholder": "Введите ваше имя",

      "contact": "Контактная информация",

      "contactPlaceholder": "Введите ваш телефон/мобильный/email",

      "company": "Название компании",

      "companyPlaceholder": "Введите название вашей компании",

      "service": "Название услуги",

      "servicePlaceholder": "Введите название услуги",

      "requirement": "Подробное описание потребностей",

      "requirementPlaceholder": "Опишите ваши индивидуальные потребности",

      "submit": "Отправить"

    },

    "validation": {

      "nameRequired": "Пожалуйста, введите имя",

      "contactRequired": "Пожалуйста, введите контактную информацию"

    },

    "messages": {

      "submitSuccess": "Успешно отправлено",

      "submitFailed": "Не удалось отправить",

      "submitFailedRetry": "Не удалось отправить, пожалуйста, повторите позже"

    }

  },

  "productDownloadDialog": {
    "logoAlt": "Логотип Yacoo",
    "title": "Информация для загрузки документа",
    "description": "Пожалуйста, заполните следующую информацию для загрузки документа",
    "form": {
      "companyName": "Название компании",
      "companyNamePlaceholder": "Введите название компании",
      "email": "Email",
      "emailPlaceholder": "Введите email",
      "mobile": "Телефон",
      "mobilePlaceholder": "Введите номер телефона",
      "qq": "QQ",
      "qqPlaceholder": "Введите QQ (необязательно)",
      "wechat": "WeChat",
      "wechatPlaceholder": "Введите WeChat (необязательно)",
      "submit": "Отправить"
    },
    "validation": {
      "companyNameRequired": "Пожалуйста, введите название компании",
      "emailRequired": "Пожалуйста, введите email",
      "emailInvalid": "Пожалуйста, введите корректный email",
      "mobileRequired": "Пожалуйста, введите номер телефона"
    },
    "messages": {
      "submitFailed": "Не удалось отправить",
      "submitFailedRetry": "Не удалось отправить, пожалуйста, повторите позже"
    }
  },
  "purchaseDialog": {

    "logoAlt": "Логотип Yacoo",

    "title": "Больше брендовых продуктов на Element Mall",

    "gotoStore": "Перейти в магазин",

    "storeInfo": "Предоставляется Element Mall под Yacoo Group"

  },

  "purchaseListDialog": {

    "logoAlt": "Логотип Yacoo",

    "productInfo": "Информация о продукте",

    "unitPrice": "Цена за единицу (с НДС)",

    "more": "Еще",

    "productCode": "Код товара:",

    "itemNumber": "Артикул:",

    "specification": "Спецификация:",

    "parameter": "Параметры:",

    "contactSales": "Связаться с продажами",

    "gotoShop": "Перейти в магазин",

    "storeInfo": "Предоставляется Element Mall под Yacoo Group"

  },

  "resumeDialog": {

    "logoAlt": "Yacoo",

    "upload": {

      "clickToUpload": "Нажмите для загрузки резюме",

      "fileFormat": "Формат файла: jpg, pdf, ppt, размер не более 5M",

      "fileSizeError": "Размер файла не должен превышать 5M",

      "fileTypeError": "Пожалуйста, загрузите файл в формате jpg, pdf или ppt"

    },

    "fileInfo": {

      "removeFile": "Удалить файл"

    },

    "submit": "Отправить",

    "messages": {

      "uploadSuccess": "Резюме успешно отправлено",

      "uploadFailed": "Не удалось загрузить, попробуйте снова",

      "jobNotExist": "Информация о вакансии не существует",

      "pleaseUploadFirst": "Пожалуйста, сначала загрузите резюме"

    }

  },

  "goodChart": {

    "logoAlt": "Логотип Yacoo",

    "companyName": "Yacoo",

    "consultationPhone": "Телефон для консультаций:",

    "productService": "Консультации по продуктам и послепродажное обслуживание:",

    "contactEmail": "Контактный email:",

    "leaveMessage": "Оставить сообщение"

  },

  "searchPage": {

    "pageTitle": "Поиск по сайту",

    "searchInfo": "Поиск: {keyword}",

    "loading": "Загрузка...",

    "noData": "Нет данных",

    "noNews": "Нет соответствующих новостей",

    "noProducts": "Нет соответствующих продуктов",

    "productInfo": {

      "casNo": "Номер CAS:",

      "itemNumber": "Артикул:",

      "specification": "Спецификация:",

      "parameter": "Параметры:",

      "price": "Цена:",

      "unit": "Единица:",

      "inquiry": "Консультация",

      "chemicalName": "Химическое название"

    },

    "newsInfo": {

      "typeTag": "Тип"

    },

    "pagination": {

      "prev": "Предыдущая",

      "next": "Следующая"

    }

  }

}
